import axios, { AxiosPromise } from 'axios';

import { Progress } from '../type';

export default class ProgressService {
  resource: string;

  constructor(baseResource: string = '') {
    this.resource = `${baseResource || ''}/api/async-progress`;
  }

  getProgresses(): AxiosPromise<Progress[]> {
    return axios.get(this.resource);
  }

  getTopic(): AxiosPromise<string> {
    return axios.get(`${this.resource}/topic`);
  }

  deleteProgress(id: any): AxiosPromise<void> {
    return axios.delete(`${this.resource}/${id}`);
  }
}
